import Arrow from './Arrow';
import Caret from './Caret';
import Chevron from './Chevron';
export const AlignedIcons = {
    Arrow,
    Caret,
    Chevron,
};
export default AlignedIcons;
